export const PRO_MINTLINK_DEV = 'https://app-test.nftkt.io/en/mint/';
export const PRO_MINTLINK = 'https://app.nftkt.io/en/mint/';
